import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as PackageInventoryStore from '../../../redux/packageInventory';
import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import type { AnyFilter, Visibility } from '../../../../shared/organizationPackages/filters';
import type { SelectOption } from '../../../types';

const FILTER_OPTIONS: SelectOption[] = [
  { value: 'public', label: 'Public' },
  { value: 'private', label: 'Private' },
];

type Props = {
  setFilters: (filters: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersProject has filters related to searching
 * by project name, import method, visibility, or project label.
 */
const PackageInventoryFiltersProjectVisibility: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const visibility = useSelector(PackageInventoryStore.selectors.getFiltersProjectVisibility);

  // map current visibility to SelectOption format
  const selectedCheckboxes = visibility.map((vis: string) => ({
    label: FILTER_OPTIONS.find(option => option.value === vis)?.label || vis,
    value: vis,
  }));

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    const selectedVisibility = newSelected.map(({ value }) => value as Visibility);
    setFilters({ visibility: selectedVisibility });
  };

  return (
    <FilterCardCheckboxes
      label="Visibility in FOSSA"
      options={FILTER_OPTIONS}
      values={selectedCheckboxes}
      onChange={onChange}
      testId="package-inventory-filters--visibility"
    />
  );
};

export default PackageInventoryFiltersProjectVisibility;
